module.exports = __webpack_public_path__ + "static/media/RECLAMACIONES_B.fae85c15.svg";